import { RouteReuseStrategy, ActivatedRouteSnapshot, DetachedRouteHandle } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {

    private storedRoutes = new Map<string, DetachedRouteHandle>();

    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return route.routeConfig?.path === 'home';
    }

    store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
        const path = route.routeConfig?.path;
        if (path) {
            this.storedRoutes.set(path, handle);
        }
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        const path = route.routeConfig?.path;
        return !!path && this.storedRoutes.has(path);
    }

    retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
        const path = route.routeConfig?.path;
        return path ? this.storedRoutes.get(path) ?? null : null;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        return future.routeConfig === curr.routeConfig;
    }
}
